import React from 'react';
import { Exercise } from '../../../../../models/Exercise';
import EAChip from "../../../../shared/Chip/EAChip";
import EATooltip from "../../../../shared/EATooltip/EATooltip";
import { useTranslation } from "react-i18next";
import useFacility from "../../../../../../utils/hooks/useFacility";

interface IProps {
  exercise: Exercise;
}

const ReservationModalAlert: React.FC<IProps> = ({ exercise }) => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const showAllStatuses = facilityIds === "1243" || facilityIds === "1241";

  const isEventPassed = new Date(exercise.startTime) <= new Date();
  const chips: JSX.Element[] = [];

  // If event has passed, show attendance status
  if (isEventPassed) {
    if (showAllStatuses && exercise.status === "A") {
      chips.push(
        <EATooltip key="absent" content={t("nieobecny_tooltip")} position="right">
          <EAChip label={t("nieobecny")} variant="warning" />
        </EATooltip>
      );
    } else if (showAllStatuses && exercise.status === "U") {
      chips.push(
        <EATooltip key="used" content={t("wykorzystany_tooltip")} position="right">
          <EAChip label={t("wykorzystany")} variant="success" />
        </EATooltip>
      );
    } else if (!showAllStatuses && exercise.status === "A") {
      chips.push(
        <EATooltip key="present" content={t("obecny_tooltip")} position="right">
          <EAChip label={t("obecny")} variant="success" />
        </EATooltip>
      );
    }

    chips.push(
      <EATooltip key="past" content={t("minelo_tooltip")} position="right">
        <EAChip label={t("minelo")} variant="dark" />
      </EATooltip>
    );
  } else {
    // For upcoming events, show reservation status
    if (exercise.status === "R") {
      chips.push(
        <EATooltip
          key="waitlist"
          content={`Lista rezerwowa, jesteś ${exercise.waitListPosition} w kolejce`}
          position="right"
        >
          <EAChip label={t("lista_rezerwowa")} variant="warning" badge={exercise.waitListPosition} />
        </EATooltip>
      );
    }

    if (exercise.deputyHumanName) {
      chips.push(
        <EATooltip
          key="deputy"
          content={`${exercise.deputyHumanName} zamiast ${exercise.humanName || t("pierwotny_trener")}`}
          position="right"
        >
          <EAChip label={t("zastepstwo")} variant="warning" />
        </EATooltip>
      );
    }

    if (exercise.status === "A" && exercise.startTime !== 1789524000000) {
      chips.push(
        <EATooltip key="registered" content={t("jestes_zapisany_tooltip")} position="right">
          <EAChip label={t("jestes_zapisany")} variant="success" />

        </EATooltip>
      );
    }
  }

  if (chips.length === 0) {
    return null;
  }

  return <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>{chips}</div>;
};

export default ReservationModalAlert;
